// @ts-nocheck
import { pathname, Router, routes } from 'svelte-hash-router';
import App from './App.svelte';
import './App.scss';
import Settings from './Settings.svelte';
import SessionLog from './SessionLog.svelte';
import ConversationPage from './ConversationPage.svelte';
import { applicationData } from './service/application-properties';
import { assertValued } from './service/util';
import setupAnalytics from './config/googleAnalyticsRegistrar';
import { uiConfigRepository } from './services';
assertValued(applicationData.backendUrl, 'applicationData.backendUrl is not defined, please, define BACKEND_URL env variable');
const uiConfig = uiConfigRepository.getUiConfig();
routes.set({
    '/conversations/:conversationId': ConversationPage,
    '/*/conversations/:conversationId': ConversationPage,
    '/settings': Settings,
    '/*/settings': Settings,
    '/session-log': SessionLog,
    '/*/session-log': SessionLog,
    '*': App
});
if (uiConfig.gaMeasurementId) {
    setupAnalytics(applicationData.gaMeasurementId);
}
export default new Router({ target: document.body });
